import { render, staticRenderFns } from "./Elev.vue?vue&type=template&id=0d0c62d0&scoped=true&"
import script from "./Elev.vue?vue&type=script&lang=js&"
export * from "./Elev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c62d0",
  null
  
)

export default component.exports